
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Logo } from '@/components/navbar/Logo';
import { Separator } from '@/components/ui/separator';
import { YoutubeIcon, FacebookIcon, InstagramIcon, Mail, Shield } from 'lucide-react';
import { toast } from 'sonner';

const Footer = () => {
  const navigate = useNavigate();

  const handleAdminClick = () => {
    const adminEmail = 'admin@example.com';
    const adminPassword = 'admin123';
    
    // Store admin credentials directly for the demo
    localStorage.setItem('adminAuth', JSON.stringify({ 
      authenticated: true, 
      role: 'admin',
      email: adminEmail 
    }));
    
    toast.success('Admin login successful!');
    navigate('/admin-dashboard');
  };

  return (
    <footer className="py-12 bg-muted/30 border-t border-border">
      <div className="container px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <Logo />
            </div>
            <Separator className="mb-4" />
            <h3 className="text-lg font-bold mb-4">Readiness on Tap</h3>
            <p className="text-muted-foreground mb-4 max-w-[360px]">
              AI-powered emergency planning for families and businesses. 
              Stay prepared for any situation.
            </p>
            
            {/* Social Media Links */}
            <div className="flex space-x-4 mt-6">
              <a href="https://www.youtube.com/@myqoop-tv" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-muted-foreground hover:text-primary transition-colors">
                <YoutubeIcon className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61574878283091" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-muted-foreground hover:text-primary transition-colors">
                <FacebookIcon className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/myqoop/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-muted-foreground hover:text-primary transition-colors">
                <InstagramIcon className="w-5 h-5" />
              </a>
              <a href="https://x.com/myqoop" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="text-muted-foreground hover:text-primary transition-colors">
                {/* X icon (formerly Twitter) */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-5 h-5"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </a>
              <a href="https://www.tiktok.com/@myqoop" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-muted-foreground hover:text-primary transition-colors">
                {/* Create a custom TikTok icon since it's not available in lucide-react */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-5 h-5"
                >
                  <path d="M9 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
                  <path d="M15 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
                  <path d="M15 8v8a4 4 0 0 1-4 4" />
                  <line x1="15" y1="4" x2="15" y2="12" />
                </svg>
              </a>
            </div>
            
            {/* Contact Email */}
            <div className="mt-4">
              <a 
                href="mailto:support@myqoop.com" 
                className="flex items-center text-muted-foreground hover:text-primary transition-colors gap-2"
              >
                <Mail className="w-4 h-4" />
                <span>support@myqoop.com</span>
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">Pages</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-muted-foreground hover:text-foreground">Home</Link></li>
              <li><Link to="/features" className="text-sm text-muted-foreground hover:text-foreground">Features</Link></li>
              <li><Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground">Pricing</Link></li>
              <li><Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground">Blog</Link></li>
              <li><Link to="/about" className="text-sm text-muted-foreground hover:text-foreground">About</Link></li>
              <li><Link to="/faq" className="text-sm text-muted-foreground hover:text-foreground">FAQ</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground">Terms of Service</Link></li>
              <li>
                <button 
                  onClick={handleAdminClick} 
                  className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1"
                >
                  <Shield className="h-3 w-3" />
                  <span>Admin</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-sm text-muted-foreground text-center">
            © 2025 Human Race (bda qoop). All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
